var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 66,
    viewBox: "0 0 279 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.1518 29.6313V48.534H91.422V40.9295H80.0876V48.534H76.2129V29.6313H80.0876V37.1997H91.422V29.6313H95.1518Z",
    fill: "#16EBC3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.926 48.5703H98.9869V29.6313H117.926V48.5703ZM114.196 33.3612H102.862V44.6956H114.196V33.3612Z",
    fill: "#16EBC3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.018 29.6313V48.5703H137.288V36.1857L131.53 41.7624L125.954 36.1857V48.5703H122.079V29.6313H124.867L131.53 36.4392L138.338 29.6313H141.018Z",
    fill: "#16EBC3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.622 33.3612V37.2359H163.686V40.9657H148.622V44.6956H163.686V48.5703H144.747V29.6313H163.686V33.3612H148.622Z",
    fill: "#16EBC3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.714 33.506V44.8404H186.778V48.5703H167.839V29.7762H186.778V33.506H171.714Z",
    fill: "#1042F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M209.87 48.5703H190.932V29.6313H194.806V44.8404H206.141V29.6313H209.87V48.5703Z",
    fill: "#1042F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M232.821 48.5703H213.882V29.6313H232.821V48.5703ZM229.091 40.9657H217.757V44.6956H229.091V40.9657ZM229.091 33.3612H217.757V37.2359H229.091V33.3612Z",
    fill: "#1042F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M240.743 33.3612V37.2359H255.807V40.9657H240.743V44.6956H255.807V48.5703H236.869V39.1008V29.6313H255.807V33.3612H240.743Z",
    fill: "#1042F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M278.9 33.3531V29.6313H259.889V40.9979H274.977V44.6191L259.889 44.7197V48.6427H278.9V37.2294H263.781V33.3531H278.9Z",
    fill: "#1042F3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M278.9 29.6313V33.3531H263.781V37.2294H278.9V48.6427H259.889V44.7197L274.977 44.6191V40.9979H259.889V29.6313H279.001",
    stroke: "#1042F3",
    strokeWidth: 0.201178
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1067 33.2727L17.8672 16.7711V5.35889L46.1067 22.4945V33.2727Z",
    fill: "#1042F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6525 32.4582L35.7501 27.4382L35.6697 16.1606L26.418 21.6366L26.6525 32.4582Z",
    fill: "#AF49FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2417 55.0481L0 38.5465L9.06069 33.2725L37.3393 50.026L28.2417 55.0481Z",
    fill: "#16EBC3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5235 43.9269L18.6233 38.907V27.814L9.5235 32.8361V43.9269Z",
    fill: "#AF49FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2422 66L37.3398 60.98V49.8892L28.2422 54.9091V66Z",
    fill: "#AF49FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2422 43.7531L37.3398 38.7332V27.6423L28.2422 32.6623V43.7531Z",
    fill: "#AF49FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2417 43.7531L9.52318 32.8159V43.9718L28.2417 54.9091V65.9999L0.00248066 49.4997L0 49.4983V38.4074V27.2515V16.1606L28.2417 32.6623V43.7531Z",
    fill: "#1042F3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8672 5.35869L46.1066 22.4943L55.2064 17.1769L26.9278 0L17.8672 5.35869ZM28.2417 32.6624L0 16.1607L9.06069 10.8867L18.5643 16.5178L27.5848 11.2559L35.6684 16.1608L26.8035 21.3997L37.3393 27.6424L28.2417 32.6624Z",
    fill: "#16EBC3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1077 33.2726L55.2074 27.9269V17.177L46.1077 22.4857V33.2726Z",
    fill: "#AF49FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b931aee24b93273c30989770522e8f9c.svg";
export { ForwardRef as ReactComponent };